<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <Avatar
        :src="initiatorAvatarSrc"
        :gap="initiatorInitials"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <span class="notification__update-item__initiator">{{ initiatorFullName }}</span>
        {{ notification.repliedOnComment ? "replied to you in" : "added a comment to" }}
        <a
          class="link is-large"
          target="_blank"
          :href="notification.itemHref"
        >
          {{ notification.itemLabel }}:
        </a>
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description"
      >
        <ReferencedText
          :resetStyle="true"
          :html="notification.comment"
        />
      </BaseSubHeading>

      <NotificationAttachmentFiles
        v-if="notification.attachments.length"
        :attachments="notification.attachments"
        :itemUrl="notification.resourceUrl"
        :attachmentsCount="notification.attachmentsCount"
      />
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import Avatar from "@/components/Avatar/index.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { AIProfile, NotificationComment } from "@/models"
import { Getters } from "@/store"
import { getInitials } from "@/utils/helpers"

import { ReferencedText } from "../../Reference"

@Options({
  name: "REPLY_COMMENT",
  components: {
    NotificationAttachmentFiles,
    NotificationTemplate,
    Avatar,
    ReferencedText
  }
})
export default class REPLY_COMMENT extends Vue {
  @Prop() readonly notification: NotificationComment
  @Getter(Getters.GET_AI_PROFILE) readonly currentAiProfile: AIProfile

  get initiatorFullName() {
    return this.notification.fromAi
      ? this.currentAiProfile.name || "AI"
      : this.notification.initiatorFullName
  }

  get initiatorAvatarSrc() {
    return this.notification.fromAi
      ? (this.currentAiProfile.picture?.pictureUrl ?? null)
      : this.notification.initiatorAvatarSrc || null
  }

  get initiatorInitials() {
    return this.notification.fromAi
      ? getInitials(this.initiatorFullName)
      : this.notification.getInitials()
  }
}
</script>
